export const TOP_BAR = {
  TODAY: {
    TH: 'วันนี้',
    EN: 'Today'
  },
  TYPEVIEW: {
    TH: [
      { label: 'ปี', value: 'year' },
      { label: 'เดือน', value: 'month' },
      // { label: 'สัปดาห์', value: 'week' },
      { label: 'วัน', value: 'day' }
    ],
    EN: [
      { label: 'year', value: 'year' },
      { label: 'month', value: 'month' },
      // { label: 'week', value: 'week' },
      { label: 'day', value: 'day' }
    ]
  }
}
